export enum PermissionLevels {
    Restricted = 0,
    View = 1,
    Edit = 2,
    Create = 3,
    Delete = 4,
}

export type PermissionTreeItem = {
    code?: string,
    level: PermissionLevels,
    children: PermissionTreeItem[],
};

export type PermissionTree = {module: string, explanation?: string, tree: PermissionTreeItem | null};
